"use strict";

/**
 * main entry point of the application
 * */
$(document).ready(function () {
	//straight-forward initialization
	site.instance = new ScnSite('#scn-site');
	site.instance.loadData(() => {
		site.instance.render().init().start();
	});
});
